import { useEffect, useRef, useState } from "react";
import { getCustomisationValue, getGroupData } from "../../../EditablePreview";
import InlineProgressBar, { convertCustomisationDataToBarSettings } from "../../progress-bar/inline-progress-bar";
import VisualisedNode, { IMAGE_MODES } from "../../VisualisedNode";
import './WaveWin.scss';

const WaveWin = (props) => {
    const node = props.node;
    let activeNode = props.activeNode !== node ? props.activeNode : node.subNodes[0];
    if (node.subNodes.indexOf(activeNode) === -1) {
        activeNode = node.subNodes[0];
    }

    return (
        <>
            <VisualisedNode {...props} node={activeNode} imageMode={IMAGE_MODES.naturalSize} style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}} />
        </>
    );
}

export default WaveWin;
